const api = 'https://us-central1-toma-iliev.cloudfunctions.net/api'

export { api };
